'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatIn = formatIn;
exports.formatOut = formatOut;
exports.defaultValueFormatter = defaultValueFormatter;
exports.fieldDataFormatter = fieldDataFormatter;

var _lodash = require('lodash');

var _Attachment = require('./Attachment');

var _Attachment2 = _interopRequireDefault(_Attachment);

var _CascadeSelect = require('./CascadeSelect');

var _CascadeSelect2 = _interopRequireDefault(_CascadeSelect);

var _RegionSelect = require('./RegionSelect');

var _RegionSelect2 = _interopRequireDefault(_RegionSelect);

var _CascadeMultiSelect = require('./CascadeMultiSelect');

var _CascadeMultiSelect2 = _interopRequireDefault(_CascadeMultiSelect);

var _MultiSelect = require('./MultiSelect');

var _MultiSelect2 = _interopRequireDefault(_MultiSelect);

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

var _Date = require('./Date');

var _Date2 = _interopRequireDefault(_Date);

var _CascadeDate = require('./CascadeDate');

var _CascadeDate2 = _interopRequireDefault(_CascadeDate);

var _RichText = require('./RichText');

var _RichText2 = _interopRequireDefault(_RichText);

var _Number = require('./Number');

var _Number2 = _interopRequireDefault(_Number);

var _PreSuffixInput = require('./PreSuffixInput');

var _PreSuffixInput2 = _interopRequireDefault(_PreSuffixInput);

var _JsonObject = require('./JsonObject');

var _JsonObject2 = _interopRequireDefault(_JsonObject);

var _FaceRecognition = require('./FaceRecognition');

var _FaceRecognition2 = _interopRequireDefault(_FaceRecognition);

var _SearchInput = require('./SearchInput');

var _SearchInput2 = _interopRequireDefault(_SearchInput);

var _FormatInput = require('./FormatInput');

var _FormatInput2 = _interopRequireDefault(_FormatInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatterMap = new Map();
formatterMap.set('Attachment', _Attachment2.default);
formatterMap.set('AddressSelect', _CascadeSelect2.default);
formatterMap.set('RegionSelect', _RegionSelect2.default);
formatterMap.set('MultiLevelAddressSelect', _CascadeSelect2.default);
formatterMap.set('CascadeSelect', _CascadeSelect2.default);
formatterMap.set('CascadeMultiSelect', _CascadeMultiSelect2.default);
formatterMap.set('Checkbox', _MultiSelect2.default);
formatterMap.set('MultiSelect', _MultiSelect2.default);
formatterMap.set('Radio', _Select2.default);
formatterMap.set('InputRadio', _Select2.default);
formatterMap.set('Select', _Select2.default);
formatterMap.set('Date', _Date2.default);
formatterMap.set('CascadeDate', _CascadeDate2.default);
formatterMap.set('RichText', _RichText2.default);
formatterMap.set('Number', _Number2.default);
formatterMap.set('FloatNumber', _Number2.default);
formatterMap.set('PreSuffixInput', _PreSuffixInput2.default);
formatterMap.set('Iframe', _JsonObject2.default);
formatterMap.set('FaceRecognition', _FaceRecognition2.default);
formatterMap.set('SearchInput', _SearchInput2.default);
formatterMap.set('FormatInput', _FormatInput2.default);

function formatIn(value, componentName) {
  var formatter = formatterMap.get(componentName);
  if (formatter && (0, _lodash.isFunction)(formatter.formatIn)) {
    for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }

    return formatter.formatIn.apply(formatter, [value].concat(rest));
  }
  return value;
}

function formatOut(value, componentName) {
  var formatter = formatterMap.get(componentName);
  if (formatter && (0, _lodash.isFunction)(formatter.formatOut)) {
    for (var _len2 = arguments.length, rest = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      rest[_key2 - 2] = arguments[_key2];
    }

    return formatter.formatOut.apply(formatter, [value].concat(rest));
  }
  return value;
}

/**
 * 以后端数据为输入值，格式化生成展示用的文本
 * @param {*} value
 * @param {*} componentName
 * @param  {...any} rest
 */
function defaultValueFormatter(value, componentName) {
  var formatter = formatterMap.get(componentName);
  if (formatter && (0, _lodash.isFunction)(formatter.defaultValueFormatter)) {
    for (var _len3 = arguments.length, rest = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      rest[_key3 - 2] = arguments[_key3];
    }

    return formatter.defaultValueFormatter.apply(formatter, [value].concat(rest));
  }
  if ((0, _lodash.isObject)(value) && !(0, _lodash.isNil)(value)) {
    return JSON.stringify(value);
  }
  return value;
}

function fieldDataFormatter(value, componentName) {
  var formatter = formatterMap.get(componentName);
  if (formatter && !(0, _lodash.isNil)(value) && (0, _lodash.isFunction)(formatter.fieldDataFormatter)) {
    for (var _len4 = arguments.length, rest = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
      rest[_key4 - 2] = arguments[_key4];
    }

    return formatter.fieldDataFormatter.apply(formatter, [value].concat(rest));
  }
  return value;
}